import { render, staticRenderFns } from "./ToxprintsChemicals.vue?vue&type=template&id=b0b91faa&scoped=true"
import script from "./ToxprintsChemicals.vue?vue&type=script&lang=js"
export * from "./ToxprintsChemicals.vue?vue&type=script&lang=js"
import style0 from "./ToxprintsChemicals.vue?vue&type=style&index=0&id=b0b91faa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0b91faa",
  null
  
)

export default component.exports